import React from 'react';
import gql from 'graphql-tag';
import {
  CheckoutOrderSummaryOrderItemSubtotalFields,
  core_apimessages_Money as Money,
} from '../schemas/rql';

type Order = CheckoutOrderSummaryOrderItemSubtotalFields.Orders;

interface Props {
  order: Order;
}

export default function CheckoutOrderSummaryOrderItemSubtotal({ order }: Props) {
  function displayPriceCurrency() {
    if (order.subtotal.listingPrice.currency === 'USD') {
      return null;
    }
    return order.subtotal.listingPrice.currency;
  }

  function hasMoreThanOneQuantity() {
    return order.quantity > 1;
  }

  function displayPrice() {
    if (order.subtotal.discounted) {
      return (
        <>
          <span data-listing-original-price className="opacity-60 td-line-through d-block">
            {listingOriginalPriceDisplay(order)}
          </span>
          <span data-order-discounted-subtotal className="cart-price-discounted">
            {order.subtotal.listingPrice.display}
            <PriceCurrencyCode currencyCode={displayPriceCurrency()} />
          </span>
        </>
      );
    }

    return (
      <>
        {order.subtotal.listingPrice.display}
        <PriceCurrencyCode currencyCode={displayPriceCurrency()} />
      </>
    );
  }

  return (
    <p className="mb-0 align-right">
      {hasMoreThanOneQuantity() &&
        <span className="weight-bold">
          {`${order.quantity}x `}
        </span>
      }
      {displayPrice()}
    </p>
  );
}

function PriceCurrencyCode({ currencyCode }: { currencyCode: string }) {
  if (!currencyCode) { return null; }

  return (
    <span className="size-60 ml-space">
      {currencyCode}
    </span>
  );
}

function listingOriginalPriceDisplay(order: Order) {
  const price = findPrice(order.listing.pricing);

  return price?.display || '';
}

function findPrice(pricing: CheckoutOrderSummaryOrderItemSubtotalFields.Pricing): Money {
  return pricing.originalPrice || pricing.buyerPrice;
}

export const CheckoutOrderSummaryOrderItemSubtotalFragment = gql`
  fragment CheckoutOrderSummaryOrderItemSubtotalFields on Checkout {
    _id
    orders {
      quantity
      listing {
        _id
        pricing {
          originalPrice {
            display
            currency
          }
          buyerPrice {
            display
            currency
          }
        }
      }
      subtotal {
        listingPrice {
          display
          currency
        }
        discounted
        discount {
          type
          label
        }
      }
    }
  }
`;
